import Cookies from 'js-cookie';

const tokenKey = 'mzcrm-token';
const tempTokenKey = 'mzcrm-token-temp';

export function hasToken(temp = false) {
  return !!Cookies.get(!temp ? tokenKey : tempTokenKey);
}

export function setToken(token, expire, temp = false) {
  const ms = expire * 1000;
  const expires_in = new Date(new Date().getTime() + ms);

  return Cookies.set(!temp ? tokenKey : tempTokenKey, token, {
    expires: expires_in,
  });
}

export function getToken(temp = false) {
  return Cookies.get(!temp ? tokenKey : tempTokenKey);
}

export function removeToken(temp = false) {
  return Cookies.remove(!temp ? tokenKey : tempTokenKey);
}
